import { useEffect, useState } from 'react';

import { FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import ContainerImg from '../../img/doctorDashboard.png';
import PatientIcon from '../../img/patientIcon.png';
import AppointmentIcon from '../../img/appointmentIcon.png';
import DollarIcon from '../../img/dollarIcon.png';
import Logo from '../../assest/images/37a39cb7092d94d7297953ad09f2dee5.png'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import axios from 'axios';

const StaffDashboard = () => {
    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
    const getGreeting = () => {
        const currentHour = new Date().getHours();

        if (currentHour < 12) {
            return "Good Morning";
        } else if (currentHour < 18) {
            return "Good Afternoon";
        } else {
            return "Good Evening";
        }
    };
    const [total, setTotal] = useState({
        TotalAppointment: null,
    });
    const [totalUsers, setTotalUsers] = useState(null);
    const [totalIncome, setTotalIncome] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [pharmacyItems, setPharmacyItems] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [schedules, setSchedules] = useState([]);

    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const response = await fetch('https://backend.amarasinghemedicare.com/appointment/all-appointment');
                if (!response.ok) {
                    throw new Error('Failed to fetch appointments');
                }
                const data = await response.json();
                setAppointments(data);
            } catch (error) {
                console.error('Error fetching appointments:', error);
            }
        };

        fetchAppointments();
    }, [])

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await fetch('https://backend.amarasinghemedicare.com/pharmacy/pharmacy');
                const data = await res.json();
                setPharmacyItems(data);
            } catch (error) {
                console.error('Error fetching pharmacy items:', error);
            }
        };

        fetchItems();
    }, []);

    useEffect(() => {
        const fetchTotalAppointments = async () => {
            try {
                const response = await axios.get('https://backend.amarasinghemedicare.com/appointment/count-appointments');
                setTotal({ TotalAppointment: response.data.totalAppointments });
            } catch (err) {
                console.error('Error:', err);
                setError('Unable to load appointment data');
            } finally {
                setLoading(false);
            }
        };

        fetchTotalAppointments();
    }, []);

    useEffect(() => {
        const fetchTotalUsers = async () => {
            try {
                const res = await axios.get('https://backend.amarasinghemedicare.com/patient/count-users');
                setTotalUsers(res.data.totalUsers);
            } catch (err) {
                setError('Failed to fetch user count');
            } finally {
                setLoading(false);
            }
        };

        fetchTotalUsers();
    }, []);

    useEffect(() => {
        const fetchTotalIncome = async () => {
            try {
                const res = await axios.get('https://backend.amarasinghemedicare.com/appointment/total-income');
                setTotalIncome(res.data.totalIncome);
            } catch (err) {
                setError('Failed to fetch income');
            } finally {
                setLoading(false);
            }
        };

        fetchTotalIncome();
    }, []);

    useEffect(() => {
        const fetchSchedules = async () => {
            try {
                const response = await axios.get('https://backend.amarasinghemedicare.com/schedule/upcoming-schedules');
                setSchedules(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching schedules:', error);
                setLoading(false);
            }
        };

        fetchSchedules();
    }, []);

    const DoctorDashboard = { TotalPatients: "100", TotalAppointment: "120", TotalPayment: "1000.00", MonthlypatientCount: "30", PreviousMonthCount: "40", PreviousMonthPresentage: "30%", CurrentMonthCount: "60", CurrentMonthPresentage: "70%" };

    return (
        <div className="bg-transparent border-2 border-[#C0C2C2] md:border-0 md:border-transparent p-2 md:p-0">
            {/* Main Container */}
            <div className="mb-1">
                {/* Container 01 */}
                <div className="grid grid-cols-1 w-full gap-4 md:grid-cols-2 lg:grid-cols-3">
                    <div className="flex  w-full bg-[#202643] py-5 px-3 xl:px-6 h-32 hover:scale-[102%] md:hover:scale-105 transition-all duration-300 shadow-lg rounded-2xl border-black border-[1px]">
                        <div className="bg-white border-4 border-[#3E36B0] w-[75px] h-[75px] content-center rounded-full">
                            <img src={AppointmentIcon} alt="Appointment" className="w-10 h-10 m-auto" />
                        </div>
                        <div className="ml-4">
                            <p className="text-[18px] font-semibold text-white">Total Appointment</p>

                            {loading ? (
                                <p className="text-[30px] font-bold text-yellow-400 -mt-2">Loading...</p>
                            ) : error ? (
                                <p className="text-[18px] font-bold text-red-400 -mt-2">0</p>
                            ) : (
                                <p className="text-[30px] font-bold text-green -mt-2">{total.TotalAppointment}</p>
                            )}

                            <p className="text-[18px] font-normal text-[#A9A9A9] -mt-2">Till Today</p>
                        </div>
                    </div>

                    <div className="flex w-full shadow-lg bg-[#97ce4fd5] py-5 px-3 xl:px-6 h-32 hover:scale-[102%] md:hover:scale-105 transition-all duration-300 rounded-2xl border-black border-[1px]">
                        <div className="bg-white border-4 border-[#3E36B0] w-[75px] h-[75px] content-center rounded-full">
                            <img src={PatientIcon} alt="patient" className="w-10 h-10 m-auto" />
                        </div>
                        <div className="ml-4">
                            <p className="text-[18px] font-semibold text-white">Registered Patients</p>
                            {loading ? (
                                <p className="text-[30px] font-bold text-yellow-400 -mt-2">Loading...</p>
                            ) : error ? (
                                <p className="text-[18px] font-bold text-red-400 -mt-2">0</p>
                            ) : (
                                <p className="text-[30px] font-bold text-[#202643] -mt-2">{totalUsers}</p>
                            )}
                            <p className="text-[18px] font-normal text-black -mt-2">Till Today</p>
                        </div>
                    </div>

                    <div className="flex  w-full bg-[#202643] py-5 px-3 xl:px-6 h-32 hover:scale-[102%] md:hover:scale-105 transition-all duration-300 shadow-lg rounded-2xl border-black border-[1px]">
                        <div className="bg-white border-4 border-[#3E36B0] w-[75px] h-[75px] content-center rounded-full">
                            <img src={DollarIcon} alt="Appointment" className="w-12 h-12 m-auto" />
                        </div>
                        <div className="ml-4">
                            <p className="text-[18px] font-semibold text-[#ffffff]">Total Income</p>
                            {loading ? (
                                <p className="text-[30px] font-bold text-yellow-300 -mt-2">Loading...</p>
                            ) : error ? (
                                <p className="text-[18px] font-bold text-red-400 -mt-2">0</p>
                            ) : (
                                <p className="text-[30px] font-bold text-green -mt-2">RS. {Number(totalIncome).toLocaleString()}</p>
                            )}
                            <p className="text-[18px] font-normal text-[#A9A9A9] -mt-2">Till Today</p>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 mt-3 gap-4 lg:grid-cols-5">
                    <div className="lg:col-span-3 w-full h-fit sm:h-[350px]">
                        <div className='flex justify-between items-center'>
                            <h2 className="text-left font-medium text-lg text-black flex gap-1">
                                {getGreeting()}
                                <span className="font-bold text-xl text-[#202643]">
                                    {localStorage.getItem("adminName")}!
                                </span>
                            </h2>

                            <h2 className="font-extralight text-xl text-[#202643]">{formattedDate}</h2>
                        </div>

                        <div className="w-full h-fit sm:h-[310px] shadow-lg mt-3 p-3 rounded-2xl bg-white border-green border-[2px]" style={{ backgroundImage: `url(${ContainerImg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                            <h2 className="text-left font-semibold text-2xl text-black">Monthly Patient Count</h2>
                            <h2 className="text-left font-semibold text-[38px] text-black my-4">{DoctorDashboard.MonthlypatientCount}</h2>
                            <div className="space-y-2 sm:flex sm:space-x-10 sm:space-y-0">
                                {/* Patient count Monthly comparison container */}
                                <div className="w-[200px] h-[130px] rounded-xl shadow-lg bg-[#fbc3c3a9] p-5 hover:scale-[102%] md:hover:scale-105  transition-all duration-300">
                                    <p className="font-semibold mt-1 text-md">Previous Month</p>
                                    <div className="flex justify-between my-3 align-middle ">
                                        <p className="font-semibold my-2 text-center  text-3xl">{DoctorDashboard.PreviousMonthCount}</p>
                                        <p className={`flex font-semibold my-2 text-sm text-center py-2 px-3 rounded-lg ${DoctorDashboard.PreviousMonthPresentage > DoctorDashboard.CurrentMonthPresentage ? 'bg-[#DFFDDD] text-[#008000]' : 'bg-[#FBC3C3] text-[#D30404]'}`}>
                                            {DoctorDashboard.PreviousMonthPresentage}
                                            {DoctorDashboard.PreviousMonthPresentage > DoctorDashboard.CurrentMonthPresentage ? <FaArrowTrendUp className="ml-2 mt-1 text-md" /> : <FaArrowTrendDown className="ml-2 mt-1 text-md" />}
                                        </p>
                                    </div>
                                </div>
                                <div className="w-[200px] h-[130px] rounded-xl shadow-lg bg-[#dffddd86] p-5 hover:scale-[102%] md:hover:scale-105  transition-all duration-300">
                                    <p className="font-semibold my-1 text-md">Current Month</p>
                                    <div className="flex justify-between my-3 align-middle">
                                        <p className="font-semibold my-2 text-center  text-3xl">{DoctorDashboard.CurrentMonthCount}</p>
                                        <p className={`flex font-semibold my-2 text-sm text-center py-2 px-3 rounded-lg ${DoctorDashboard.CurrentMonthPresentage > DoctorDashboard.PreviousMonthPresentage ? 'bg-[#DFFDDD] text-[#008000]' : 'bg-[#FBC3C3] text-[#D30404]'}`}>
                                            {DoctorDashboard.CurrentMonthPresentage}
                                            {DoctorDashboard.CurrentMonthPresentage > DoctorDashboard.PreviousMonthPresentage ? <FaArrowTrendUp className="ml-2 mt-1 text-md" /> : <FaArrowTrendDown className="ml-2 mt-1 text-md" />}
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/*  */}
                    <div className="lg:col-span-2 w-full h-[350px]">
                        <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            navigation
                            pagination={{ clickable: true }}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            loop={true}
                            slidesPerView={1}
                            spaceBetween={20}
                            className="h-full"
                        >
                            {pharmacyItems.map((item) => (
                                <SwiperSlide key={item.id}>
                                    <div className="flex items-center gap-4 bg-white rounded-2xl p-4 h-[350px] border-green border-[2px]">
                                        <img
                                            src={`https://backend.amarasinghemedicare.com/Upload/Pharmacy/${item.image}`}
                                            alt={item.itemName}
                                            className="w-32 h-32 object-cover rounded"
                                        />
                                        <div className="text-left">
                                            <h2 className="text-xl font-bold text-black">{item.itemName}</h2>
                                            <p className="text-sm text-gray-700 mb-2">{item.description}</p>
                                            <p className="text-green-600 font-semibold">Rs. {item.price}</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                </div>
                {/* Container 03 */}
                <div className="grid grid-cols-1 gap-4 mt-3 lg:grid-cols-2">
                    <div className="w-full h-[565px] bg-white shadow-lg p-4 overflow-hidden overflow-y-auto rounded-2xl border-green border-[2px]">
                        <h1 className="text-left font-semibold text-2xl text-black mb-4">Patients being examined today.</h1>

                        {appointments.length > 0 ? (
                            appointments.map((appointment, index) => (
                                <div
                                    key={index}
                                    className={`p-3 bg-[#fafafa] rounded-lg flex gap-3 shadow-xl border-[1px] border-fontDark mb-5 hover:scale-[102%] md:hover:scale-[102%] transition-all duration-300`}
                                >
                                    <img src={Logo} alt="" className="w-[20%] bg-white p-4 rounded-lg shadow-lg" />

                                    <div className="flex justify-center flex-col gap-1">
                                        <h1 className="text-sm font-semibold">
                                            {appointment.firstName} {appointment.lastName} - <span>{appointment.mobileNo}</span>
                                        </h1>
                                        <h2 className="text-sm">
                                            Dr <span>{appointment.doctor_name}</span>
                                        </h2>
                                        <h1 className="text-sm">
                                            <span>
                                                {appointment.timeSlot} | slot {appointment.sheet_No}
                                            </span>{' '}
                                            |
                                            <span
                                                className={`px-3 py-1 rounded-lg font-semibold ml-2 ${appointment.status === 'paid' ? 'bg-green text-white' : 'bg-[#b95c4a] text-white'
                                                    }`}
                                            >
                                                {appointment.status}
                                            </span>
                                        </h1>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className={`p-3 bg-[#fafafa] rounded-lg flex items-start justify-center gap-3 shadow-xl border-[1px] border-fontDark mb-5 hover:scale-[102%] md:hover:scale-[102%] transition-all duration-300`}>
                                <p className="text-center text-gray-500">No patients found for today.</p>
                            </div>
                        )}



                    </div>

                    <div className="w-full h-[565px] bg-fontDark shadow-lg p-4 overflow-hidden overflow-y-auto rounded-2xl border-green border-[2px] scrollbar-hide relative">
                        <h1 className="text-left font-semibold text-2xl text-white mb-4">Upcoming Schedules.</h1>

                        <div >
                            {schedules.length > 0 ? (
                                schedules.map((schedule, index) => (
                                    <div key={index} className={`p-3 bg-[#fafafa] rounded-lg flex gap-3 shadow-xl border-[1px] border-green mb-5 hover:scale-[102%] md:hover:scale-[102%] transition-all duration-300`}>
                                        <img className="w-[20%] bg-white bg-cover rounded-lg shadow-lg"
                                            src={
                                                schedule?.doctor_image
                                                    ? `https://backend.amarasinghemedicare.com/${schedule.doctor_image.replace(/\\/g, '/')}`
                                                    : require('../../assest/images/Doctor.png') // Or use a public path if needed
                                            } alt="" />

                                        <div className='flex justify-center flex-col gap-1'>
                                            <h1 className="text-sm font-semibold bg-[#4397c79d] w-fit px-2 p-1 rounded-lg text-white">
                                                Dr {schedule.doctor_name}
                                            </h1>
                                            <h1 className='font-semibold'>{new Date(schedule.date).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric',
                                            })}</h1>

                                            <h2 className="text-sm font-light">
                                                Starting Time: <span className='bg-green p-1 rounded-lg text-white font-semibold'>{schedule.start_time}</span> | Ending Time: <span className='bg-red p-1 rounded-lg text-white font-semibold'>{schedule.end_time}</span>
                                            </h2>
                                        </div>

                                    </div>
                                ))
                            ) : (
                                <div className="p-3 bg-[#fafafa] rounded-lg flex items-start justify-center gap-3 shadow-xl border-[1px] border-fontDark mb-5 hover:scale-[102%] md:hover:scale-[102%] transition-all duration-300">
                                    <p className="text-center text-gray-500">No upcoming schedules found.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StaffDashboard;